<div class="modal-header m-transparent">
  <button type="button" class="close" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-header d-flex justify-content-center text-center">
  <h1 class="modal-title">{{'financing-sources-popup.title' | translate}}</h1>
</div>

<div class="modal-body d-flex flex-column align-items-center border-bottom">
  <div>
    <span class="text-center font-weight-bold">{{"financing-sources-popup.body"|translate}} {{sum}} {{"financing-sources-popup.body2"|translate}}</span>
  </div>
  <div>
    <span class="text-center font-weight-bold">{{"financing-sources-popup.body3"|translate}}</span>
  </div>
</div>
<div class="modal-body d-flex flex-column align-items-center">
  <div class="text-center">
    <div class="d-flex justify-content-around width-100 justify-content-around-mobile">
      <button class="app-button button-primary" (click)="activeModal.close()">{{"financing-sources-popup.btn-proceed"|translate}}</button>
      <button class="app-button button-secondery" (click)="exit()">{{"financing-sources-popup.btn-exit"|translate}}</button>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/financing-sources-popup/financing-sources-popup.component.html